import { Sphere } from '@react-three/drei';
import React from 'react'

export const GlassDome = ({ radius = 1.17, position = [0,1.6,0],...props }) => {
    return (
        <Sphere position={position} args={[radius, 32, 32, 0, 2 * Math.PI, 0, 0.5 * Math.PI]}>
            <meshPhysicalMaterial depthWrite={false} color={0xf0f0fd} transmission={1} roughness={0} ior={1.33} thickness={0.005} />
        </Sphere>
    )
}
export default GlassDome;